import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, GenerateVoucherResult } from 't4core';


@Component({
  selector: 'generateVouchersResultDialog',
  templateUrl: 'generateVouchersResultDialog.html',
})
export class GenerateVouchersResultDialog extends DialogBase {

  public result: GenerateVoucherResult;

    constructor(
      public dialogRef: MatDialogRef<GenerateVouchersResultDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("GenerateVouchersResultDialog");
        this.result = data; 
    }
}
